export default __webpack_public_path__ + "static/media/mask_icon.7304363e.svg";